<template>
    <div>
        <div style="display: block; margin-top: 10px;">
            <b-alert variant="secondary" show>
                <div style="width: 250px; margin: 5px; display: inline-block; vertical-align: top;">
                    <div>FINAL ETA</div>
                    <date-picker 
                        v-model="date_range" 
                        format="MM-DD-YYYY" 
                        valueType="format"
                        style="width: 220px; font-size: 15px; display: block;"
                        placeholder="DATE OR DATE RANGE"
                        range
                    ></date-picker>
                </div>
            </b-alert>
        </div>


        <div>
            <div v-if="items_being_loaded == true">
                <loading 
                :active="true" 
                :can-cancel="false" 
                :is-full-page="true">
                </loading>
            </div>

            <div v-else>
                <div v-if="items.length == 0">
                    <b-alert show variant="warning"> NO CONTAINER ORDERS</b-alert>
                </div>
                <div v-else class="accordion" role="tablist">
                    <div v-for="item,idx in filter" v-if="(item.data || {}).receiving_location" class="mb-1">

                        <table style="width: 100%;">
                            <thead>
                                <tr>
                                    <td class="srr" style="width: 200px;">
                                        PO #
                                    </td>
                                    <td class="srr" style="width: 150px;">
                                        CREATED AT
                                    </td>
                                    <td class="srr" style="width: 150px;">
                                        FINAL ETA
                                    </td>
                                    <td class="srr" style="width: 100px;">
                                        VENDOR
                                    </td>
                                    <td class="srr" style="width: 150px;">
                                        STATUS
                                    </td>
                                    <td class="srr" style="width: 100px;">
                                        CONTAINER #
                                    </td>
                                    <td class="srr" style="width: 100px;">
                                        INVOICE #
                                    </td>
                                    <td class="srr" style="width: 80px;">
                                        FREIGHT COMP
                                    </td>
                                    <!-- <td class="srr" style="width: 100px;">
                                        RCVNG DATE
                                    </td> -->
                                    <td class="srr" style="width: 100px;">
                                        RECVNG LOCT
                                    </td>
                                    <td class="srr" style="width: 100px;">
                                        CATEGORIES
                                    </td>
                                    <td class="srr" style="width: 80px;">
                                        CUBES
                                    </td>
                                    <td class="srr" style="width: 80px;">
                                        QTY ORDERED
                                    </td>
                                    <td class="srr" style="width: 80px;">
                                        QTY RECEIVED
                                    </td>
                                    <td class="srr" style="width: 80px;">
                                        ACTION
                                    </td>
                                </tr>
                            </thead>

                            <tbody>
                                <tr>
                                    <td class="srrv">
                                        {{item.data.po_number}}
                                    </td>
                                    <td class="srrv">
                                        {{item.created_at}}
                                    </td>
                                    <td class="srrv" style="background: lightblue;">
                                        {{item.data.final_eta}}
                                    </td>
                                    <td class="srrv">
                                        {{packet.vendorsdict[item.data.vendor_id]}}
                                    </td>
                                    <td class="srrv">
                                        {{co_statusesdict[item.data.status]}}
                                    </td>
                                    <td class="srrv">
                                        {{item.data.container_num}}
                                    </td>
                                    <td class="srrv">
                                        {{item.data.truck_inv_num}}
                                    </td>
                                    <td class="srrv">
                                        {{item.data.container_freight_company}}
                                    </td>
                                    <!-- <td class="srrv">
                                        RCVNG DATE
                                    </td> -->
                                    <td class="srrv">
                                        {{packet.locationsdict[item.data.receiving_location]}}
                                    </td>
                                    <td class="srrv">
                                        <div v-for="ct,ctidx in item.categories" v-bind:key="ctidx" v-if="ct" class="box">
                                            {{packet.categoriesdict[ct]}}
                                        </div>
                                    </td>
                                    <td class="srrv">
                                        {{item.cubes}}
                                    </td>
                                    <td class="srrv">
                                        {{item.quantity_ordered}}
                                    </td>
                                    <td class="srrv">
                                       {{item.received_items}}
                                    </td>
                                    <td class="srrv">
                                        <b-button block v-b-toggle="'accordion-'+idx" variant="info" size="sm" @click="get_container_order_items(item);">ITEMS</b-button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        
                        <b-collapse :id="'accordion-'+idx" accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <!-- <div v-if="item.products_loading == true">
                                    <loading 
                                    :active="true" 
                                    :can-cancel="false" 
                                    :is-full-page="false">
                                    </loading>
                                </div>
                                <div v-else>
                                    <div v-if="item.products.length == 0">
                                        <b-alert show>NO ITEMS FOR THIS CONTAINER ORDER </b-alert>
                                    </div>
                                    <div v-else>
                                        {{item.products}}
                                    </div>
                                </div> -->
                                <ContainerOrderItems :viewdata="{container_order_id: item.id, container_order_vendor_id: item.data.vendor_id, read_only: true}" />
                                
                            </b-card-body>
                        </b-collapse>
                    </div>


                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import moment from 'moment'
    import mappings from '@/utilities/mappings'
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import Requestor from '@/utilities/Requestor';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';
    import VueSimpleSuggest from 'vue-simple-suggest'
    import 'vue-simple-suggest/dist/styles.css' // Optional CSS


    //import { AgGridVue } from "ag-grid-vue";  // the AG Grid Vue Component
    //import { reactive, onMounted, ref } from "vue";

    //import "ag-grid-community/dist/styles/ag-grid.css"; // Core grid CSS, always needed
    //import "ag-grid-community/dist/styles/ag-theme-balham.css"; // Optional theme CSS

    //import ItemComments from '@/components/importables/ItemComments'
    import ContainerOrderItems from "@/components/VendorOrders/ContainerOrderItems"

    export default {
        name: "ContainerOrders",
        props: [],
        components: {flatPickr, Loading,DatePicker,VueSimpleSuggest, ContainerOrderItems},
        data: function(){
            return {
                packet: {},
                items: [],
                items_being_loaded: null,
                statuses: [
                    {value: 1, text: "OPEN"},
                    {value: 2, text: "BOOKING REQUEST"},
                    {value: 3, text: "BOOKED/ISF FILING"},
                    {value: 4, text: "IN-TRANSIT"},
                    {value: 5, text: "ARRIVAL NOTICE"},
                    {value: 6, text: "RECEIVED"},
                    {value: 7, text: "COMPLETED"},
                    {value: 8, text: "ARCHIVED"},
                ],
                co_statusesdict: {
                    1: "OPEN",
                    2: "BOOKING REQUEST",
                    3: "BOOKED/ISF FILING",
                    4: "IN-TRANSIT",
                    5: "ARRIVAL NOTICE",
                    6: "RECEIVED",
                    7: "COMPLETED",
                    8: "ARCHIVED"
                },

                pms: [
                    {value: "CHECK", text: "CHECK"},
                    {value: "WIRE", text: "WIRE"},
                    {value: "CASH", text: "CASH"},
                ],
                container_order_id: null,
                create_new: false,
                date_range: [],


            }
        },
        computed: {
            filter: function(){
                let that = this;

                return this.items.filter(function(d){
                    //console.log(d.data.final_eta, that.date_range)
                    return (
                        
                        ((that.date_range.length == 2 && that.date_range.includes(null) == false) ? d.data.final_eta >= that.date_range[0] && d.data.final_eta <= that.date_range[1] : true )
                    )
                })
            }
        },
        methods: {
            get_container_order_items: function(container_order){
                let data = {container_order_id: container_order.id}
                let path = "/api/vendor/get_container_order_items/"
                let that = this;
                let s = function(response) {
                    if (response.data.error){
                        that.$bvToast.toast(
                            "ERROR RETRIEVING CONTAINER ORDER ITEMS", 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        container_order.products = response.data.result;
                        console.log(container_order.products)
                        //that.fetch_init();
                    }
                    container_order.products_loading = false;
                }

                let f = function(error) {
                    that.$bvToast.toast(
                        "Error retrieving products.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    container_order.products_loading = false;
                }
                container_order.products = [];
                container_order.products_loading = true;
                Requestor.getSyncP(path, data, this, s, f);
            },
            add_new_container_order: function(){
                //this.update_container_order({data: {vendor_id}});
                let item = {
                    data: {
                        vendor_id: null,
                        po_number: null,
                    },
                    id: null,
                    created_at: null,
                    updated_at: null,
                }
                this.items.splice(0, 0, item);
            },
            validate: function(item){
                let errors = [];
                if (!item.data.vendor_id){
                    errors.push({message: "PLEASE INDICATE A VENDOR FOR THIS ORDER BEFORE SAVING."})
                }
                return errors
            },
            update_container_order: function(item){
                let data = item;
                let that = this;

                let errors = this.validate(item);
                if (errors.length > 0){
                    this.$vex.dialog.alert(
                        {message: errors[0].message}
                    );
                    return
                }
                let path = "/api/vendor/update_container_order/"
                let s = function(response) {
                    if (response.data.result){
                        that.$bvToast.toast(
                            "SAVED", 
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    //that.items_being_loaded = false
                }

                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error occurred in saving. Please try again.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    //that.items_being_loaded = false
                }
                //this.items_being_loaded = true;
                Requestor.postSyncP(path, data, this, s, f);
            }, 
            fetch_orders: function(){
                let data = {status: this.status};
                let that = this;
                let path = "/api/vendor/get_container_orders/"
                let s = function(response) {
                    if (response.data.result){
                        that.items = response.data.result;
                        //that.items = that.items.map(function(d){d.products = []; d.products_loading = null; return d});
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.items_being_loaded = false
                }

                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error occurred. Please try again.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.items_being_loaded = false
                }
                this.items_being_loaded = true;
                Requestor.getAsyncP(path, data, this, s, f);
            },
            view_item: function(item){
                this.container_order_id = item.id;
                this.$bvModal.show("modal-co-items");
            },
            close_co_items: function(){
                this.$bvModal.hide("modal-co-items");
                this.fetch_orders()
            }
        },
        created: function(){
            this.packet = JSON.parse(localStorage.packet);
            this.packet.userDetails = JSON.parse(localStorage.userDetails);
            this.fetch_orders();    
        }

    }
</script>

<style scoped>
    
    .srr {
        font-size: 11px;
        text-align: center;
        background: #efefef;
        border: 1px solid #010101;
    }

    .srrv {
        font-size: 13px;
        text-align: center;
        background: white;
        border: 1px solid #010101;
        padding: 5px;
        background-color: #f9fbe7;
    }

    .box {
        padding: 1px;
        text-align: center;
        margin: 3px;
        background: lightyellow;
        color: black;
        border: 1px solid black;
        font-size: 11px;
    }
</style>


// WEBPACK FOOTER //
// src/components/IncomingOutGoing/ContainerOrders.vue